import { createContext, useContext, useState, useEffect } from 'react';
import { publicApi } from '../lib/api';

const SettingsContext = createContext(null);

const defaultSettings = {
  company_info: {
    name: 'NYRAV TOURS AND TRAVELS',
    address: '44, PB Road, Suhagpur, Rehabari, Guwahati-08',
    phone: '+91 9181268900',
    email: 'nyravtravels@gmail.com',
    tagline: 'Your Gateway to Unforgettable Adventures'
  },
  social_media: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    twitter: 'https://twitter.com',
    youtube: 'https://youtube.com'
  },
  whatsapp_number: '+919181268900',
  logo: null,
  favicon: null
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await publicApi.getSettings();
      if (response.data) {
        setSettings(response.data);
      }
    } catch (error) {
      console.error('Error loading site settings:', error);
    } finally {
      setLoading(false);
    }
  };

  // Refresh settings (useful after admin updates)
  const refreshSettings = () => {
    loadSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
}

// Helper hook to get specific settings
export function useCompanyInfo() {
  const { settings } = useSettings();
  return settings.company_info;
}

export function useSocialMedia() {
  const { settings } = useSettings();
  return settings.social_media;
}

export function useWhatsApp() {
  const { settings } = useSettings();
  return settings.whatsapp_number;
}
